import { Button, Dialog, DialogActions, DialogTitle, Grid, IconButton, Stack } from '@mui/material'
import React from 'react'
import CustomTextField from '../common/CustomTextField'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import SmallPlusButton from '../common/SmallPlusButton'

interface EventContactProps {
    phone: string
    name: string
    onDelete: () => void
    onChangeName: (name: string) => void
    onChangePhone: (phone: string) => void
    isFirst?: boolean
    onAdd: () => void
}

const EventContact: React.FC<EventContactProps> = ({ phone, name, onChangeName, onChangePhone, onDelete, onAdd, isFirst }: EventContactProps) => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false)

    const handleOpenDialog = () => {
        setIsDialogOpen(true)
    }

    const handleCloseDialog = () => {
        setIsDialogOpen(false)
    }

    return (
        <>
            <Grid item xs={6}>
                <CustomTextField fullWidth value={name} label='Kontaktní osoba' onChange={(e) => onChangeName(e.target.value)} />
            </Grid>
            <Grid item xs={6}>
                <Stack direction='row' spacing={3}>
                    <CustomTextField fullWidth value={phone} label='Telefonní číslo' onChange={(e) => onChangePhone(e.target.value)} />
                    {
                        isFirst ? <SmallPlusButton onClick={onAdd} /> : <div>
                            <IconButton color='error' size='small' onClick={handleOpenDialog}>
                                <DeleteOutlineRoundedIcon />
                            </IconButton>

                            <Dialog open={isDialogOpen} onClose={handleCloseDialog}>
                                <DialogTitle>Opravdu chcete smazat {name + ' ' + phone}?</DialogTitle>

                                <DialogActions>
                                    <Button onClick={handleCloseDialog} variant='outlined'>
                                        Ne
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            onDelete()
                                            handleCloseDialog()
                                        }}
                                        autoFocus
                                        variant='contained'
                                        color='error'
                                    >
                                        Ano
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    }

                </Stack>
            </Grid>
        </>
    )
}

export default EventContact
